import { SkeletonParent } from '@/components/ui/Skeleton/skeleton';

export const ProviderSkeleton = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <SkeletonParent className="mb-1.75 rounded-2xl overflow-hidden bg-main-800 md:h-34.25 w-full h-27 max-w-50" />
      <SkeletonParent className="h-4 w-24" />
    </div>
  );
};
